var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddDocumentDisabledBlankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.0566,
    y: 0.811035,
    width: 8.72093,
    height: 57.2327,
    fill: "url(#paint0_linear_5123_14009)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.347656,
    y: 34.0381,
    width: 8.58491,
    height: 58.1395,
    transform: "rotate(-90 0.347656 34.0381)",
    fill: "url(#paint1_linear_5123_14009)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5123_14009",
    x1: 29.4171,
    y1: 0.811035,
    x2: 29.4171,
    y2: 58.0437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5123_14009",
    x1: 4.64011,
    y1: 34.0381,
    x2: 4.64011,
    y2: 92.1776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#D8D8D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocumentDisabledBlankIcon);
export default __webpack_public_path__ + "static/media/add-document-disabled-blank-icon.47c6612aa5202045e5a7593a37b2d9b2.svg";
export { ForwardRef as ReactComponent };